/**
 * The "Latest nightly run" box under the group chart (TRA-1402): how it
 * writes the change. Whether it shows is the api's call alone: the box
 * renders the newest night the api names (`latest_night`), however old,
 * and nothing when no night has scored the group.
 */

import { formatScore, type ScoreFormat } from './format'

/** A signed change in the group's own format: "+2.1%", "-0.021". */
export function formatDelta(delta: number, format: ScoreFormat): string {
  const sign = delta < 0 ? '-' : '+'
  return `${sign}${formatScore(Math.abs(delta), format)}`
}
